// Named customer testimonials for the homepage.
// Avatars use tasteful monogram tiles by default. Swap the `avatar` field
// with a URL (e.g. "/testimonials/roy.jpg") once real photography is captured.

const TESTIMONIALS = [
  {
    name: "Dr Roy",
    role: "Doctor",
    quote:
      "What impressed me most was the timeline — the team promised a date and delivered on it, no drama, no delays. Rare in this industry.",
    initials: "DR",
    tone: "navy",
    avatar: null,
  },
  {
    name: "Ravi Kumar",
    role: "Architect",
    quote:
      "Reliable and accountable — every specification I sent came back exactly as drawn, and the site coordination was refreshingly transparent from start to finish.",
    initials: "RK",
    tone: "teal",
    avatar: null,
  },
  {
    name: "Devesh Singh",
    role: "Businessman",
    quote:
      "The taste level is on par with brands twice their price, and the quality of finish is what actually sold me — every panel edge, every hinge feels considered.",
    initials: "DS",
    tone: "coral",
    avatar: null,
  },
];

const TONE_MAP = {
  navy: "bg-navy text-white",
  teal: "bg-teal text-white",
  coral: "bg-coral text-white",
};

const Avatar = ({ initials, tone, avatar, name }) => {
  if (avatar) {
    return (
      <img
        src={avatar}
        alt={name}
        loading="lazy"
        className="w-14 h-14 md:w-16 md:h-16 rounded-full object-cover shrink-0"
      />
    );
  }
  return (
    <div
      aria-hidden="true"
      className={`w-14 h-14 md:w-16 md:h-16 rounded-full shrink-0 flex items-center justify-center font-display text-lg md:text-xl tracking-wider ${TONE_MAP[tone] || TONE_MAP.navy}`}
    >
      {initials}
    </div>
  );
};

export const Testimonials = () => {
  return (
    <section data-testid="testimonials" className="bg-ivory py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20 reveal">
          <div className="max-w-2xl">
            <div className="overline mb-4">People who trusted us</div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight font-light">
              In their <span className="italic text-navy">own words</span>.
            </h2>
          </div>
          <p className="md:text-right md:max-w-sm text-black/60">
            Clients, designers, and dealer partners who commissioned a Tarush space and stayed for the next one.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={t.name}
              data-testid={`testimonial-${t.initials.toLowerCase()}`}
              className="reveal bg-white border-t-4 border-gold p-8 md:p-10 flex flex-col h-full shadow-[0_2px_20px_rgba(41,72,144,0.04)]"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="font-display text-3xl text-coral leading-none">"</div>
              <blockquote className="mt-3 text-base md:text-lg text-black/85 leading-relaxed flex-1">
                {t.quote}
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-4 border-t border-brandgray pt-6">
                <Avatar {...t} />
                <div>
                  <div className="font-display text-lg md:text-xl leading-tight text-black">{t.name}</div>
                  <div className="text-sm text-teal mt-0.5">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
